import React, { createContext, useContext, useState, useCallback, useRef } from 'react';
import ConfirmModal from './ConfirmModal';

const ConfirmContext = createContext(null);
let globalConfirmHandler = null;

export const ConfirmProvider = ({ children }) => {
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    title: 'Are you sure?',
    message: 'Please confirm this action.',
    confirmLabel: 'Confirm',
    cancelLabel: 'Cancel',
    danger: false,
    type: 'danger',
  });

  const resolverRef = useRef(null);

  const confirm = useCallback(
    ({
      title = 'Are you sure?',
      message = 'Please confirm this action.',
      confirmLabel = 'Confirm',
      cancelLabel = 'Cancel',
      danger = false,
      type = danger ? 'danger' : 'success',
    } = {}) => {
      return new Promise((resolve) => {
        resolverRef.current = resolve;
        setModalConfig({
          isOpen: true,
          title,
          message,
          confirmLabel,
          cancelLabel,
          danger,
          type,
        });
      });
    },
    []
  );

  globalConfirmHandler = confirm;

  const handleConfirm = () => {
    setModalConfig((prev) => ({ ...prev, isOpen: false }));
    if (resolverRef.current) {
      resolverRef.current(true);
      resolverRef.current = null;
    }
  };

  const handleCancel = () => {
    setModalConfig((prev) => ({ ...prev, isOpen: false }));
    if (resolverRef.current) {
      resolverRef.current(false);
      resolverRef.current = null;
    }
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <ConfirmModal
        isOpen={modalConfig.isOpen}
        title={modalConfig.title}
        message={modalConfig.message}
        confirmLabel={modalConfig.confirmLabel}
        cancelLabel={modalConfig.cancelLabel}
        danger={modalConfig.danger}
        type={modalConfig.type}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => {
  const ctx = useContext(ConfirmContext);
  return ctx || globalConfirmHandler;
};

export const showConfirm = (options) => {
  if (globalConfirmHandler) {
    return globalConfirmHandler(options);
  }
  return Promise.resolve(false);
};

export default ConfirmContext;
